import createArrayMethod from './create-array-method';
export default createArrayMethod('filter');
